import { DefaultMessages } from '../interfaces';

// Mensagens de erro padrão
export const DEFAULT_MESSAGES: DefaultMessages = {
    required: 'Obrigatório',
    minLength: 'Mínimo de {minLength} caracteres',
    maxLength: 'Máximo de {maxLength} caracteres',
    min: 'Valor mínimo: {min}',
    max: 'Valor máximo: {max}',
    pattern: 'Formato inválido',
    email: 'E-mail inválido',
    password: 'A senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, uma minúscula, um número e um caractere especial',
    custom: 'Valor inválido',
};

// Mensagens específicas por tipo de campo
export const FIELD_SPECIFIC_MESSAGES: { [key: string]: DefaultMessages } = {
    email: {
        email: 'Digite um e-mail válido',
        maxLength: 'E-mail muito longo',
    },
    password: {
        minLength: 'Senha deve ter pelo menos {minLength} caracteres',
        password: 'A senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, uma minúscula, um número e um caractere especial',
    },
    phone: {
        pattern: 'Telefone deve estar no formato (11) 99999-9999',
    },
    cpf: {
        pattern: 'CPF deve estar no formato 000.000.000-00',
    },
    cnpj: {
        pattern: 'CNPJ deve estar no formato 00.000.000/0000-00',
    },
    cep: {
        pattern: 'CEP deve estar no formato 00000-000',
    },
    number: {
        min: 'Valor deve ser maior que {min}',
    },
};

// Placeholders padrão por tipo de campo
export const DEFAULT_PLACEHOLDERS: { [key: string]: string } = {
    text: 'Digite o texto',
    email: 'seu@email.com',
    password: 'Digite sua senha',
    phone: '(11) 99999-9999',
    cpf: '000.000.000-00',
    cnpj: '00.000.000/0000-00',
    cep: '00000-000',
    number: 'Digite um número',
    date: 'Selecione uma data',
    textarea: 'Digite o texto',
    select: 'Selecione uma opção',
};
